import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=c5cf281e&"
import script from "./language-select.vue?vue&type=script&lang=js&"
export * from "./language-select.vue?vue&type=script&lang=js&"
import style0 from "./language-select.vue?vue&type=style&index=0&id=c5cf281e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports